import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
import { site } from '../data/site';
const companyLinks = [{
  label: 'Home',
  to: '/'
}, {
  label: 'About Us',
  to: '/about'
}, {
  label: 'What We Offer',
  to: '/what-we-offer'
}, {
  label: 'Contact Us',
  to: '/contact'
}];
const legalLinks = [{
  label: 'Privacy Policy',
  to: '/privacy-policy'
}, {
  label: 'Terms & Conditions',
  to: '/terms-and-conditions'
}, {
  label: 'Refund Policy',
  to: '/refund-policy'
}, {
  label: 'Digital Delivery Policy',
  to: '/digital-delivery-policy'
}];
export function Footer() {
  return <footer className="bg-white" data-id="element-22" data-mp="3ldamdcihtxib">
      <div aria-hidden="true" className="h-1 w-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-23" data-mp="3le2kov3h69ca" />
      <div className="border-b border-navy-100 bg-brand-indigo/[0.035]" data-id="element-24" data-mp="29ynnbq7ctfgn">
        <div className="mx-auto max-w-content px-6 py-16" data-id="element-25" data-mp="2a1jkhcbdo041">
          <div className="grid gap-12 md:grid-cols-4" data-id="element-26" data-mp="2ez1k2c3i92zd">
            <div className="md:col-span-2" data-id="element-27" data-mp="3l9ac9f9lwy2u">
              <img src={site.logoUrl} alt={`${site.brandName} logo`} className="h-16 w-auto" data-id="element-28" data-mp="3la2akxul99wt" />
              <p className="mt-5 max-w-sm text-sm leading-relaxed text-navy-500" data-id="element-29" data-mp="3v7gbfp413q40">
                {site.brandName} creates and distributes digital products for
                educational, creative and entertainment purposes. All products
                are digital and delivered electronically. No physical items are
                shipped.
              </p>
              <a href={`mailto:${site.supportEmail}`} className="mt-5 inline-flex items-center gap-2 rounded-lg border border-brand-indigo/25 bg-white px-4 py-2.5 text-sm font-medium text-brand-indigo transition-colors hover:border-brand-indigo hover:text-brand-violet" data-id="element-30" data-mp="31upzjlpifqf">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-31" data-mp="mrwplb5ot9yz" />
                {site.supportEmail}
              </a>
            </div>

            <nav aria-label="Company" data-id="element-32" data-mp="tw5xq4ifnmlo">
              <h2 className="text-xs font-semibold uppercase tracking-widest text-brand-indigo" data-id="element-33" data-mp="tt088o5w6ipf">
                Company
              </h2>
              <span aria-hidden="true" className="mt-3 block h-0.5 w-8 rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet" data-id="element-34" data-mp="13sr4aua3p5rm" />
              <ul className="mt-4 space-y-3" data-id="element-35" data-mp="1clmaprbb17iz">
                {companyLinks.map(link => <li key={link.to} data-id="element-36" data-mp="1hkp5mixklxd8">
                    <Link to={link.to} className="text-sm text-navy-600 transition-colors hover:text-brand-indigo" data-id="element-37" data-mp="1hjnu6dcn78uz">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>

            <nav aria-label="Legal" data-id="element-38" data-mp="3ocpyfksh05za">
              <h2 className="text-xs font-semibold uppercase tracking-widest text-brand-violet" data-id="element-39" data-mp="3odhrooylhrme">
                Policies
              </h2>
              <span aria-hidden="true" className="mt-3 block h-0.5 w-8 rounded-full bg-gradient-to-r from-brand-violet to-brand-cyan" data-id="element-40" data-mp="2ag5firxejeh6" />
              <ul className="mt-4 space-y-3" data-id="element-41" data-mp="21mab5m43ts2l">
                {legalLinks.map(link => <li key={link.to} data-id="element-42" data-mp="1wnywmy2v6te1">
                    <Link to={link.to} className="text-sm text-navy-600 transition-colors hover:text-brand-violet" data-id="element-43" data-mp="1wp08v5vm9lxc">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-content px-6 py-8" data-id="element-44" data-mp="2fegnex44zewr">
        <p className="text-sm text-navy-600" data-id="element-45" data-mp="2fdym3m2maahz">
          {site.brandName} is operated by {site.legalEntity}.
        </p>
        <p className="mt-2 text-sm text-navy-400" data-id="element-46" data-mp="18vrybtdkwcbz">
          © {site.copyrightYear} {site.legalEntity}. All rights reserved.
        </p>
      </div>
    </footer>;
}